module.exports = __webpack_public_path__ + "img/TruPath-2.56cdcfa0.jpg";